import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { addMonths, format, subMonths } from 'date-fns'

export default function usePhysicianDutyConflict() {
  const conflicts = ref([])
  const date = ref(new Date())

  const load = () => {
    const d = format(date.value, 'yyyy-MM')
    store.dispatch('app-reports/fetchConflicts', { date: d })
      .then(response => {
        conflicts.value = response.data.data ?? []
      })
  }
  load()

  watch([date], () => {
    load()
  })

  const previousDate = () => {
    date.value = subMonths(date.value, 1)
  }

  const nextDate = () => {
    date.value = addMonths(date.value, 1)
  }

  return {
    date,
    conflicts,
    previousDate,
    nextDate,
  }
}
